import { default as _91_46_46_46slug_93B2i8KeOwebMeta } from "C:/Users/Administrator/Desktop/new_website/nuxt3Template-master/pages/[...slug].vue?macro=true";
import { default as aboutBpKyS8uXb3Meta } from "C:/Users/Administrator/Desktop/new_website/nuxt3Template-master/pages/about.vue?macro=true";
import { default as contactrcQJ3IgNtlMeta } from "C:/Users/Administrator/Desktop/new_website/nuxt3Template-master/pages/contact.vue?macro=true";
import { default as _91id_93TYcJ3EdTZFMeta } from "C:/Users/Administrator/Desktop/new_website/nuxt3Template-master/pages/detail/[id].vue?macro=true";
import { default as healthjF9pGnsRT9Meta } from "C:/Users/Administrator/Desktop/new_website/nuxt3Template-master/pages/health.vue?macro=true";
import { default as indexCN1i0zFyx0Meta } from "C:/Users/Administrator/Desktop/new_website/nuxt3Template-master/pages/index.vue?macro=true";
import { default as aboutG5qtHWUOs6Meta } from "C:/Users/Administrator/Desktop/new_website/nuxt3Template-master/pages/m/about.vue?macro=true";
import { default as contactYj08sit80EMeta } from "C:/Users/Administrator/Desktop/new_website/nuxt3Template-master/pages/m/aboutGbh/contact.vue?macro=true";
import { default as developedgBsVxcolvhMeta } from "C:/Users/Administrator/Desktop/new_website/nuxt3Template-master/pages/m/aboutGbh/developed.vue?macro=true";
import { default as enterpriseYEQl0bOwMOMeta } from "C:/Users/Administrator/Desktop/new_website/nuxt3Template-master/pages/m/aboutGbh/enterprise.vue?macro=true";
import { default as honorz2PDMKEYKrMeta } from "C:/Users/Administrator/Desktop/new_website/nuxt3Template-master/pages/m/aboutGbh/honor.vue?macro=true";
import { default as starsNfxCMKIzxMeta } from "C:/Users/Administrator/Desktop/new_website/nuxt3Template-master/pages/m/aboutGbh/star.vue?macro=true";
import { default as contactUsCWFvnk7UNUMeta } from "C:/Users/Administrator/Desktop/new_website/nuxt3Template-master/pages/m/contactUs/contactUs.vue?macro=true";
import { default as recruit8wJYDx310mMeta } from "C:/Users/Administrator/Desktop/new_website/nuxt3Template-master/pages/m/contactUs/recruit.vue?macro=true";
import { default as indexeCEERwnOK5Meta } from "C:/Users/Administrator/Desktop/new_website/nuxt3Template-master/pages/m/health/index.vue?macro=true";
import { default as indexByhRd3wvznMeta } from "C:/Users/Administrator/Desktop/new_website/nuxt3Template-master/pages/m/index.vue?macro=true";
import { default as _91id_93AiuCf9tnuPMeta } from "C:/Users/Administrator/Desktop/new_website/nuxt3Template-master/pages/m/newsCenter/[id].vue?macro=true";
import { default as indexTSqZ9DOqYkMeta } from "C:/Users/Administrator/Desktop/new_website/nuxt3Template-master/pages/m/newsCenter/index.vue?macro=true";
import { default as _91proTwoDetail_93qz7P1vPq95Meta } from "C:/Users/Administrator/Desktop/new_website/nuxt3Template-master/pages/m/product/[proTwoDetail].vue?macro=true";
import { default as proFive9qS4tGkcVdMeta } from "C:/Users/Administrator/Desktop/new_website/nuxt3Template-master/pages/m/product/proFive.vue?macro=true";
import { default as proFourXH3q2tnjaiMeta } from "C:/Users/Administrator/Desktop/new_website/nuxt3Template-master/pages/m/product/proFour.vue?macro=true";
import { default as proOneUIQ38JvLLiMeta } from "C:/Users/Administrator/Desktop/new_website/nuxt3Template-master/pages/m/product/proOne.vue?macro=true";
import { default as proThree3xzJienSmpMeta } from "C:/Users/Administrator/Desktop/new_website/nuxt3Template-master/pages/m/product/proThree.vue?macro=true";
import { default as proTworbeVbMuQMJMeta } from "C:/Users/Administrator/Desktop/new_website/nuxt3Template-master/pages/m/product/proTwo.vue?macro=true";
import { default as newsCenterLear6urRGjMeta } from "C:/Users/Administrator/Desktop/new_website/nuxt3Template-master/pages/newsCenter.vue?macro=true";
import { default as _91Id_93eGEKSCAc9sMeta } from "C:/Users/Administrator/Desktop/new_website/nuxt3Template-master/pages/proDetail/[Id].vue?macro=true";
import { default as productryg68fgQLAMeta } from "C:/Users/Administrator/Desktop/new_website/nuxt3Template-master/pages/product.vue?macro=true";
export default [
  {
    name: _91_46_46_46slug_93B2i8KeOwebMeta?.name ?? "slug___zh-CN",
    path: _91_46_46_46slug_93B2i8KeOwebMeta?.path ?? "/:slug(.*)*",
    meta: _91_46_46_46slug_93B2i8KeOwebMeta || {},
    alias: _91_46_46_46slug_93B2i8KeOwebMeta?.alias || [],
    redirect: _91_46_46_46slug_93B2i8KeOwebMeta?.redirect || undefined,
    component: () => import("C:/Users/Administrator/Desktop/new_website/nuxt3Template-master/pages/[...slug].vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46slug_93B2i8KeOwebMeta?.name ?? "slug___en-US",
    path: _91_46_46_46slug_93B2i8KeOwebMeta?.path ?? "/en-US/:slug(.*)*",
    meta: _91_46_46_46slug_93B2i8KeOwebMeta || {},
    alias: _91_46_46_46slug_93B2i8KeOwebMeta?.alias || [],
    redirect: _91_46_46_46slug_93B2i8KeOwebMeta?.redirect || undefined,
    component: () => import("C:/Users/Administrator/Desktop/new_website/nuxt3Template-master/pages/[...slug].vue").then(m => m.default || m)
  },
  {
    name: aboutBpKyS8uXb3Meta?.name ?? "about___zh-CN",
    path: aboutBpKyS8uXb3Meta?.path ?? "/about",
    meta: aboutBpKyS8uXb3Meta || {},
    alias: aboutBpKyS8uXb3Meta?.alias || [],
    redirect: aboutBpKyS8uXb3Meta?.redirect || undefined,
    component: () => import("C:/Users/Administrator/Desktop/new_website/nuxt3Template-master/pages/about.vue").then(m => m.default || m)
  },
  {
    name: aboutBpKyS8uXb3Meta?.name ?? "about___en-US",
    path: aboutBpKyS8uXb3Meta?.path ?? "/en-US/about",
    meta: aboutBpKyS8uXb3Meta || {},
    alias: aboutBpKyS8uXb3Meta?.alias || [],
    redirect: aboutBpKyS8uXb3Meta?.redirect || undefined,
    component: () => import("C:/Users/Administrator/Desktop/new_website/nuxt3Template-master/pages/about.vue").then(m => m.default || m)
  },
  {
    name: contactrcQJ3IgNtlMeta?.name ?? "contact___zh-CN",
    path: contactrcQJ3IgNtlMeta?.path ?? "/contact",
    meta: contactrcQJ3IgNtlMeta || {},
    alias: contactrcQJ3IgNtlMeta?.alias || [],
    redirect: contactrcQJ3IgNtlMeta?.redirect || undefined,
    component: () => import("C:/Users/Administrator/Desktop/new_website/nuxt3Template-master/pages/contact.vue").then(m => m.default || m)
  },
  {
    name: contactrcQJ3IgNtlMeta?.name ?? "contact___en-US",
    path: contactrcQJ3IgNtlMeta?.path ?? "/en-US/contact",
    meta: contactrcQJ3IgNtlMeta || {},
    alias: contactrcQJ3IgNtlMeta?.alias || [],
    redirect: contactrcQJ3IgNtlMeta?.redirect || undefined,
    component: () => import("C:/Users/Administrator/Desktop/new_website/nuxt3Template-master/pages/contact.vue").then(m => m.default || m)
  },
  {
    name: _91id_93TYcJ3EdTZFMeta?.name ?? "detail-id___zh-CN",
    path: _91id_93TYcJ3EdTZFMeta?.path ?? "/detail/:id()",
    meta: _91id_93TYcJ3EdTZFMeta || {},
    alias: _91id_93TYcJ3EdTZFMeta?.alias || [],
    redirect: _91id_93TYcJ3EdTZFMeta?.redirect || undefined,
    component: () => import("C:/Users/Administrator/Desktop/new_website/nuxt3Template-master/pages/detail/[id].vue").then(m => m.default || m)
  },
  {
    name: _91id_93TYcJ3EdTZFMeta?.name ?? "detail-id___en-US",
    path: _91id_93TYcJ3EdTZFMeta?.path ?? "/en-US/detail/:id()",
    meta: _91id_93TYcJ3EdTZFMeta || {},
    alias: _91id_93TYcJ3EdTZFMeta?.alias || [],
    redirect: _91id_93TYcJ3EdTZFMeta?.redirect || undefined,
    component: () => import("C:/Users/Administrator/Desktop/new_website/nuxt3Template-master/pages/detail/[id].vue").then(m => m.default || m)
  },
  {
    name: healthjF9pGnsRT9Meta?.name ?? "health___zh-CN",
    path: healthjF9pGnsRT9Meta?.path ?? "/health",
    meta: healthjF9pGnsRT9Meta || {},
    alias: healthjF9pGnsRT9Meta?.alias || [],
    redirect: healthjF9pGnsRT9Meta?.redirect || undefined,
    component: () => import("C:/Users/Administrator/Desktop/new_website/nuxt3Template-master/pages/health.vue").then(m => m.default || m)
  },
  {
    name: healthjF9pGnsRT9Meta?.name ?? "health___en-US",
    path: healthjF9pGnsRT9Meta?.path ?? "/en-US/health",
    meta: healthjF9pGnsRT9Meta || {},
    alias: healthjF9pGnsRT9Meta?.alias || [],
    redirect: healthjF9pGnsRT9Meta?.redirect || undefined,
    component: () => import("C:/Users/Administrator/Desktop/new_website/nuxt3Template-master/pages/health.vue").then(m => m.default || m)
  },
  {
    name: indexCN1i0zFyx0Meta?.name ?? "index___zh-CN",
    path: indexCN1i0zFyx0Meta?.path ?? "/",
    meta: indexCN1i0zFyx0Meta || {},
    alias: indexCN1i0zFyx0Meta?.alias || [],
    redirect: indexCN1i0zFyx0Meta?.redirect || undefined,
    component: () => import("C:/Users/Administrator/Desktop/new_website/nuxt3Template-master/pages/index.vue").then(m => m.default || m)
  },
  {
    name: indexCN1i0zFyx0Meta?.name ?? "index___en-US",
    path: indexCN1i0zFyx0Meta?.path ?? "/en-US",
    meta: indexCN1i0zFyx0Meta || {},
    alias: indexCN1i0zFyx0Meta?.alias || [],
    redirect: indexCN1i0zFyx0Meta?.redirect || undefined,
    component: () => import("C:/Users/Administrator/Desktop/new_website/nuxt3Template-master/pages/index.vue").then(m => m.default || m)
  },
  {
    name: aboutG5qtHWUOs6Meta?.name ?? "m-about___zh-CN",
    path: aboutG5qtHWUOs6Meta?.path ?? "/m/about",
    meta: aboutG5qtHWUOs6Meta || {},
    alias: aboutG5qtHWUOs6Meta?.alias || [],
    redirect: aboutG5qtHWUOs6Meta?.redirect || undefined,
    component: () => import("C:/Users/Administrator/Desktop/new_website/nuxt3Template-master/pages/m/about.vue").then(m => m.default || m)
  },
  {
    name: aboutG5qtHWUOs6Meta?.name ?? "m-about___en-US",
    path: aboutG5qtHWUOs6Meta?.path ?? "/en-US/m/about",
    meta: aboutG5qtHWUOs6Meta || {},
    alias: aboutG5qtHWUOs6Meta?.alias || [],
    redirect: aboutG5qtHWUOs6Meta?.redirect || undefined,
    component: () => import("C:/Users/Administrator/Desktop/new_website/nuxt3Template-master/pages/m/about.vue").then(m => m.default || m)
  },
  {
    name: contactYj08sit80EMeta?.name ?? "m-aboutGbh-contact___zh-CN",
    path: contactYj08sit80EMeta?.path ?? "/m/aboutGbh/contact",
    meta: contactYj08sit80EMeta || {},
    alias: contactYj08sit80EMeta?.alias || [],
    redirect: contactYj08sit80EMeta?.redirect || undefined,
    component: () => import("C:/Users/Administrator/Desktop/new_website/nuxt3Template-master/pages/m/aboutGbh/contact.vue").then(m => m.default || m)
  },
  {
    name: contactYj08sit80EMeta?.name ?? "m-aboutGbh-contact___en-US",
    path: contactYj08sit80EMeta?.path ?? "/en-US/m/aboutGbh/contact",
    meta: contactYj08sit80EMeta || {},
    alias: contactYj08sit80EMeta?.alias || [],
    redirect: contactYj08sit80EMeta?.redirect || undefined,
    component: () => import("C:/Users/Administrator/Desktop/new_website/nuxt3Template-master/pages/m/aboutGbh/contact.vue").then(m => m.default || m)
  },
  {
    name: developedgBsVxcolvhMeta?.name ?? "m-aboutGbh-developed___zh-CN",
    path: developedgBsVxcolvhMeta?.path ?? "/m/aboutGbh/developed",
    meta: developedgBsVxcolvhMeta || {},
    alias: developedgBsVxcolvhMeta?.alias || [],
    redirect: developedgBsVxcolvhMeta?.redirect || undefined,
    component: () => import("C:/Users/Administrator/Desktop/new_website/nuxt3Template-master/pages/m/aboutGbh/developed.vue").then(m => m.default || m)
  },
  {
    name: developedgBsVxcolvhMeta?.name ?? "m-aboutGbh-developed___en-US",
    path: developedgBsVxcolvhMeta?.path ?? "/en-US/m/aboutGbh/developed",
    meta: developedgBsVxcolvhMeta || {},
    alias: developedgBsVxcolvhMeta?.alias || [],
    redirect: developedgBsVxcolvhMeta?.redirect || undefined,
    component: () => import("C:/Users/Administrator/Desktop/new_website/nuxt3Template-master/pages/m/aboutGbh/developed.vue").then(m => m.default || m)
  },
  {
    name: enterpriseYEQl0bOwMOMeta?.name ?? "m-aboutGbh-enterprise___zh-CN",
    path: enterpriseYEQl0bOwMOMeta?.path ?? "/m/aboutGbh/enterprise",
    meta: enterpriseYEQl0bOwMOMeta || {},
    alias: enterpriseYEQl0bOwMOMeta?.alias || [],
    redirect: enterpriseYEQl0bOwMOMeta?.redirect || undefined,
    component: () => import("C:/Users/Administrator/Desktop/new_website/nuxt3Template-master/pages/m/aboutGbh/enterprise.vue").then(m => m.default || m)
  },
  {
    name: enterpriseYEQl0bOwMOMeta?.name ?? "m-aboutGbh-enterprise___en-US",
    path: enterpriseYEQl0bOwMOMeta?.path ?? "/en-US/m/aboutGbh/enterprise",
    meta: enterpriseYEQl0bOwMOMeta || {},
    alias: enterpriseYEQl0bOwMOMeta?.alias || [],
    redirect: enterpriseYEQl0bOwMOMeta?.redirect || undefined,
    component: () => import("C:/Users/Administrator/Desktop/new_website/nuxt3Template-master/pages/m/aboutGbh/enterprise.vue").then(m => m.default || m)
  },
  {
    name: honorz2PDMKEYKrMeta?.name ?? "m-aboutGbh-honor___zh-CN",
    path: honorz2PDMKEYKrMeta?.path ?? "/m/aboutGbh/honor",
    meta: honorz2PDMKEYKrMeta || {},
    alias: honorz2PDMKEYKrMeta?.alias || [],
    redirect: honorz2PDMKEYKrMeta?.redirect || undefined,
    component: () => import("C:/Users/Administrator/Desktop/new_website/nuxt3Template-master/pages/m/aboutGbh/honor.vue").then(m => m.default || m)
  },
  {
    name: honorz2PDMKEYKrMeta?.name ?? "m-aboutGbh-honor___en-US",
    path: honorz2PDMKEYKrMeta?.path ?? "/en-US/m/aboutGbh/honor",
    meta: honorz2PDMKEYKrMeta || {},
    alias: honorz2PDMKEYKrMeta?.alias || [],
    redirect: honorz2PDMKEYKrMeta?.redirect || undefined,
    component: () => import("C:/Users/Administrator/Desktop/new_website/nuxt3Template-master/pages/m/aboutGbh/honor.vue").then(m => m.default || m)
  },
  {
    name: starsNfxCMKIzxMeta?.name ?? "m-aboutGbh-star___zh-CN",
    path: starsNfxCMKIzxMeta?.path ?? "/m/aboutGbh/star",
    meta: starsNfxCMKIzxMeta || {},
    alias: starsNfxCMKIzxMeta?.alias || [],
    redirect: starsNfxCMKIzxMeta?.redirect || undefined,
    component: () => import("C:/Users/Administrator/Desktop/new_website/nuxt3Template-master/pages/m/aboutGbh/star.vue").then(m => m.default || m)
  },
  {
    name: starsNfxCMKIzxMeta?.name ?? "m-aboutGbh-star___en-US",
    path: starsNfxCMKIzxMeta?.path ?? "/en-US/m/aboutGbh/star",
    meta: starsNfxCMKIzxMeta || {},
    alias: starsNfxCMKIzxMeta?.alias || [],
    redirect: starsNfxCMKIzxMeta?.redirect || undefined,
    component: () => import("C:/Users/Administrator/Desktop/new_website/nuxt3Template-master/pages/m/aboutGbh/star.vue").then(m => m.default || m)
  },
  {
    name: contactUsCWFvnk7UNUMeta?.name ?? "m-contactUs-contactUs___zh-CN",
    path: contactUsCWFvnk7UNUMeta?.path ?? "/m/contactUs/contactUs",
    meta: contactUsCWFvnk7UNUMeta || {},
    alias: contactUsCWFvnk7UNUMeta?.alias || [],
    redirect: contactUsCWFvnk7UNUMeta?.redirect || undefined,
    component: () => import("C:/Users/Administrator/Desktop/new_website/nuxt3Template-master/pages/m/contactUs/contactUs.vue").then(m => m.default || m)
  },
  {
    name: contactUsCWFvnk7UNUMeta?.name ?? "m-contactUs-contactUs___en-US",
    path: contactUsCWFvnk7UNUMeta?.path ?? "/en-US/m/contactUs/contactUs",
    meta: contactUsCWFvnk7UNUMeta || {},
    alias: contactUsCWFvnk7UNUMeta?.alias || [],
    redirect: contactUsCWFvnk7UNUMeta?.redirect || undefined,
    component: () => import("C:/Users/Administrator/Desktop/new_website/nuxt3Template-master/pages/m/contactUs/contactUs.vue").then(m => m.default || m)
  },
  {
    name: recruit8wJYDx310mMeta?.name ?? "m-contactUs-recruit___zh-CN",
    path: recruit8wJYDx310mMeta?.path ?? "/m/contactUs/recruit",
    meta: recruit8wJYDx310mMeta || {},
    alias: recruit8wJYDx310mMeta?.alias || [],
    redirect: recruit8wJYDx310mMeta?.redirect || undefined,
    component: () => import("C:/Users/Administrator/Desktop/new_website/nuxt3Template-master/pages/m/contactUs/recruit.vue").then(m => m.default || m)
  },
  {
    name: recruit8wJYDx310mMeta?.name ?? "m-contactUs-recruit___en-US",
    path: recruit8wJYDx310mMeta?.path ?? "/en-US/m/contactUs/recruit",
    meta: recruit8wJYDx310mMeta || {},
    alias: recruit8wJYDx310mMeta?.alias || [],
    redirect: recruit8wJYDx310mMeta?.redirect || undefined,
    component: () => import("C:/Users/Administrator/Desktop/new_website/nuxt3Template-master/pages/m/contactUs/recruit.vue").then(m => m.default || m)
  },
  {
    name: indexeCEERwnOK5Meta?.name ?? "m-health___zh-CN",
    path: indexeCEERwnOK5Meta?.path ?? "/m/health",
    meta: indexeCEERwnOK5Meta || {},
    alias: indexeCEERwnOK5Meta?.alias || [],
    redirect: indexeCEERwnOK5Meta?.redirect || undefined,
    component: () => import("C:/Users/Administrator/Desktop/new_website/nuxt3Template-master/pages/m/health/index.vue").then(m => m.default || m)
  },
  {
    name: indexeCEERwnOK5Meta?.name ?? "m-health___en-US",
    path: indexeCEERwnOK5Meta?.path ?? "/en-US/m/health",
    meta: indexeCEERwnOK5Meta || {},
    alias: indexeCEERwnOK5Meta?.alias || [],
    redirect: indexeCEERwnOK5Meta?.redirect || undefined,
    component: () => import("C:/Users/Administrator/Desktop/new_website/nuxt3Template-master/pages/m/health/index.vue").then(m => m.default || m)
  },
  {
    name: indexByhRd3wvznMeta?.name ?? "m___zh-CN",
    path: indexByhRd3wvznMeta?.path ?? "/m",
    meta: indexByhRd3wvznMeta || {},
    alias: indexByhRd3wvznMeta?.alias || [],
    redirect: indexByhRd3wvznMeta?.redirect || undefined,
    component: () => import("C:/Users/Administrator/Desktop/new_website/nuxt3Template-master/pages/m/index.vue").then(m => m.default || m)
  },
  {
    name: indexByhRd3wvznMeta?.name ?? "m___en-US",
    path: indexByhRd3wvznMeta?.path ?? "/en-US/m",
    meta: indexByhRd3wvznMeta || {},
    alias: indexByhRd3wvznMeta?.alias || [],
    redirect: indexByhRd3wvznMeta?.redirect || undefined,
    component: () => import("C:/Users/Administrator/Desktop/new_website/nuxt3Template-master/pages/m/index.vue").then(m => m.default || m)
  },
  {
    name: _91id_93AiuCf9tnuPMeta?.name ?? "m-newsCenter-id___zh-CN",
    path: _91id_93AiuCf9tnuPMeta?.path ?? "/m/newsCenter/:id()",
    meta: _91id_93AiuCf9tnuPMeta || {},
    alias: _91id_93AiuCf9tnuPMeta?.alias || [],
    redirect: _91id_93AiuCf9tnuPMeta?.redirect || undefined,
    component: () => import("C:/Users/Administrator/Desktop/new_website/nuxt3Template-master/pages/m/newsCenter/[id].vue").then(m => m.default || m)
  },
  {
    name: _91id_93AiuCf9tnuPMeta?.name ?? "m-newsCenter-id___en-US",
    path: _91id_93AiuCf9tnuPMeta?.path ?? "/en-US/m/newsCenter/:id()",
    meta: _91id_93AiuCf9tnuPMeta || {},
    alias: _91id_93AiuCf9tnuPMeta?.alias || [],
    redirect: _91id_93AiuCf9tnuPMeta?.redirect || undefined,
    component: () => import("C:/Users/Administrator/Desktop/new_website/nuxt3Template-master/pages/m/newsCenter/[id].vue").then(m => m.default || m)
  },
  {
    name: indexTSqZ9DOqYkMeta?.name ?? "m-newsCenter___zh-CN",
    path: indexTSqZ9DOqYkMeta?.path ?? "/m/newsCenter",
    meta: indexTSqZ9DOqYkMeta || {},
    alias: indexTSqZ9DOqYkMeta?.alias || [],
    redirect: indexTSqZ9DOqYkMeta?.redirect || undefined,
    component: () => import("C:/Users/Administrator/Desktop/new_website/nuxt3Template-master/pages/m/newsCenter/index.vue").then(m => m.default || m)
  },
  {
    name: indexTSqZ9DOqYkMeta?.name ?? "m-newsCenter___en-US",
    path: indexTSqZ9DOqYkMeta?.path ?? "/en-US/m/newsCenter",
    meta: indexTSqZ9DOqYkMeta || {},
    alias: indexTSqZ9DOqYkMeta?.alias || [],
    redirect: indexTSqZ9DOqYkMeta?.redirect || undefined,
    component: () => import("C:/Users/Administrator/Desktop/new_website/nuxt3Template-master/pages/m/newsCenter/index.vue").then(m => m.default || m)
  },
  {
    name: _91proTwoDetail_93qz7P1vPq95Meta?.name ?? "m-product-proTwoDetail___zh-CN",
    path: _91proTwoDetail_93qz7P1vPq95Meta?.path ?? "/m/product/:proTwoDetail()",
    meta: _91proTwoDetail_93qz7P1vPq95Meta || {},
    alias: _91proTwoDetail_93qz7P1vPq95Meta?.alias || [],
    redirect: _91proTwoDetail_93qz7P1vPq95Meta?.redirect || undefined,
    component: () => import("C:/Users/Administrator/Desktop/new_website/nuxt3Template-master/pages/m/product/[proTwoDetail].vue").then(m => m.default || m)
  },
  {
    name: _91proTwoDetail_93qz7P1vPq95Meta?.name ?? "m-product-proTwoDetail___en-US",
    path: _91proTwoDetail_93qz7P1vPq95Meta?.path ?? "/en-US/m/product/:proTwoDetail()",
    meta: _91proTwoDetail_93qz7P1vPq95Meta || {},
    alias: _91proTwoDetail_93qz7P1vPq95Meta?.alias || [],
    redirect: _91proTwoDetail_93qz7P1vPq95Meta?.redirect || undefined,
    component: () => import("C:/Users/Administrator/Desktop/new_website/nuxt3Template-master/pages/m/product/[proTwoDetail].vue").then(m => m.default || m)
  },
  {
    name: proFive9qS4tGkcVdMeta?.name ?? "m-product-proFive___zh-CN",
    path: proFive9qS4tGkcVdMeta?.path ?? "/m/product/proFive",
    meta: proFive9qS4tGkcVdMeta || {},
    alias: proFive9qS4tGkcVdMeta?.alias || [],
    redirect: proFive9qS4tGkcVdMeta?.redirect || undefined,
    component: () => import("C:/Users/Administrator/Desktop/new_website/nuxt3Template-master/pages/m/product/proFive.vue").then(m => m.default || m)
  },
  {
    name: proFive9qS4tGkcVdMeta?.name ?? "m-product-proFive___en-US",
    path: proFive9qS4tGkcVdMeta?.path ?? "/en-US/m/product/proFive",
    meta: proFive9qS4tGkcVdMeta || {},
    alias: proFive9qS4tGkcVdMeta?.alias || [],
    redirect: proFive9qS4tGkcVdMeta?.redirect || undefined,
    component: () => import("C:/Users/Administrator/Desktop/new_website/nuxt3Template-master/pages/m/product/proFive.vue").then(m => m.default || m)
  },
  {
    name: proFourXH3q2tnjaiMeta?.name ?? "m-product-proFour___zh-CN",
    path: proFourXH3q2tnjaiMeta?.path ?? "/m/product/proFour",
    meta: proFourXH3q2tnjaiMeta || {},
    alias: proFourXH3q2tnjaiMeta?.alias || [],
    redirect: proFourXH3q2tnjaiMeta?.redirect || undefined,
    component: () => import("C:/Users/Administrator/Desktop/new_website/nuxt3Template-master/pages/m/product/proFour.vue").then(m => m.default || m)
  },
  {
    name: proFourXH3q2tnjaiMeta?.name ?? "m-product-proFour___en-US",
    path: proFourXH3q2tnjaiMeta?.path ?? "/en-US/m/product/proFour",
    meta: proFourXH3q2tnjaiMeta || {},
    alias: proFourXH3q2tnjaiMeta?.alias || [],
    redirect: proFourXH3q2tnjaiMeta?.redirect || undefined,
    component: () => import("C:/Users/Administrator/Desktop/new_website/nuxt3Template-master/pages/m/product/proFour.vue").then(m => m.default || m)
  },
  {
    name: proOneUIQ38JvLLiMeta?.name ?? "m-product-proOne___zh-CN",
    path: proOneUIQ38JvLLiMeta?.path ?? "/m/product/proOne",
    meta: proOneUIQ38JvLLiMeta || {},
    alias: proOneUIQ38JvLLiMeta?.alias || [],
    redirect: proOneUIQ38JvLLiMeta?.redirect || undefined,
    component: () => import("C:/Users/Administrator/Desktop/new_website/nuxt3Template-master/pages/m/product/proOne.vue").then(m => m.default || m)
  },
  {
    name: proOneUIQ38JvLLiMeta?.name ?? "m-product-proOne___en-US",
    path: proOneUIQ38JvLLiMeta?.path ?? "/en-US/m/product/proOne",
    meta: proOneUIQ38JvLLiMeta || {},
    alias: proOneUIQ38JvLLiMeta?.alias || [],
    redirect: proOneUIQ38JvLLiMeta?.redirect || undefined,
    component: () => import("C:/Users/Administrator/Desktop/new_website/nuxt3Template-master/pages/m/product/proOne.vue").then(m => m.default || m)
  },
  {
    name: proThree3xzJienSmpMeta?.name ?? "m-product-proThree___zh-CN",
    path: proThree3xzJienSmpMeta?.path ?? "/m/product/proThree",
    meta: proThree3xzJienSmpMeta || {},
    alias: proThree3xzJienSmpMeta?.alias || [],
    redirect: proThree3xzJienSmpMeta?.redirect || undefined,
    component: () => import("C:/Users/Administrator/Desktop/new_website/nuxt3Template-master/pages/m/product/proThree.vue").then(m => m.default || m)
  },
  {
    name: proThree3xzJienSmpMeta?.name ?? "m-product-proThree___en-US",
    path: proThree3xzJienSmpMeta?.path ?? "/en-US/m/product/proThree",
    meta: proThree3xzJienSmpMeta || {},
    alias: proThree3xzJienSmpMeta?.alias || [],
    redirect: proThree3xzJienSmpMeta?.redirect || undefined,
    component: () => import("C:/Users/Administrator/Desktop/new_website/nuxt3Template-master/pages/m/product/proThree.vue").then(m => m.default || m)
  },
  {
    name: proTworbeVbMuQMJMeta?.name ?? "m-product-proTwo___zh-CN",
    path: proTworbeVbMuQMJMeta?.path ?? "/m/product/proTwo",
    meta: proTworbeVbMuQMJMeta || {},
    alias: proTworbeVbMuQMJMeta?.alias || [],
    redirect: proTworbeVbMuQMJMeta?.redirect || undefined,
    component: () => import("C:/Users/Administrator/Desktop/new_website/nuxt3Template-master/pages/m/product/proTwo.vue").then(m => m.default || m)
  },
  {
    name: proTworbeVbMuQMJMeta?.name ?? "m-product-proTwo___en-US",
    path: proTworbeVbMuQMJMeta?.path ?? "/en-US/m/product/proTwo",
    meta: proTworbeVbMuQMJMeta || {},
    alias: proTworbeVbMuQMJMeta?.alias || [],
    redirect: proTworbeVbMuQMJMeta?.redirect || undefined,
    component: () => import("C:/Users/Administrator/Desktop/new_website/nuxt3Template-master/pages/m/product/proTwo.vue").then(m => m.default || m)
  },
  {
    name: newsCenterLear6urRGjMeta?.name ?? "newsCenter___zh-CN",
    path: newsCenterLear6urRGjMeta?.path ?? "/newsCenter",
    meta: newsCenterLear6urRGjMeta || {},
    alias: newsCenterLear6urRGjMeta?.alias || [],
    redirect: newsCenterLear6urRGjMeta?.redirect || undefined,
    component: () => import("C:/Users/Administrator/Desktop/new_website/nuxt3Template-master/pages/newsCenter.vue").then(m => m.default || m)
  },
  {
    name: newsCenterLear6urRGjMeta?.name ?? "newsCenter___en-US",
    path: newsCenterLear6urRGjMeta?.path ?? "/en-US/newsCenter",
    meta: newsCenterLear6urRGjMeta || {},
    alias: newsCenterLear6urRGjMeta?.alias || [],
    redirect: newsCenterLear6urRGjMeta?.redirect || undefined,
    component: () => import("C:/Users/Administrator/Desktop/new_website/nuxt3Template-master/pages/newsCenter.vue").then(m => m.default || m)
  },
  {
    name: _91Id_93eGEKSCAc9sMeta?.name ?? "proDetail-Id___zh-CN",
    path: _91Id_93eGEKSCAc9sMeta?.path ?? "/proDetail/:Id()",
    meta: _91Id_93eGEKSCAc9sMeta || {},
    alias: _91Id_93eGEKSCAc9sMeta?.alias || [],
    redirect: _91Id_93eGEKSCAc9sMeta?.redirect || undefined,
    component: () => import("C:/Users/Administrator/Desktop/new_website/nuxt3Template-master/pages/proDetail/[Id].vue").then(m => m.default || m)
  },
  {
    name: _91Id_93eGEKSCAc9sMeta?.name ?? "proDetail-Id___en-US",
    path: _91Id_93eGEKSCAc9sMeta?.path ?? "/en-US/proDetail/:Id()",
    meta: _91Id_93eGEKSCAc9sMeta || {},
    alias: _91Id_93eGEKSCAc9sMeta?.alias || [],
    redirect: _91Id_93eGEKSCAc9sMeta?.redirect || undefined,
    component: () => import("C:/Users/Administrator/Desktop/new_website/nuxt3Template-master/pages/proDetail/[Id].vue").then(m => m.default || m)
  },
  {
    name: productryg68fgQLAMeta?.name ?? "product___zh-CN",
    path: productryg68fgQLAMeta?.path ?? "/product",
    meta: productryg68fgQLAMeta || {},
    alias: productryg68fgQLAMeta?.alias || [],
    redirect: productryg68fgQLAMeta?.redirect || undefined,
    component: () => import("C:/Users/Administrator/Desktop/new_website/nuxt3Template-master/pages/product.vue").then(m => m.default || m)
  },
  {
    name: productryg68fgQLAMeta?.name ?? "product___en-US",
    path: productryg68fgQLAMeta?.path ?? "/en-US/product",
    meta: productryg68fgQLAMeta || {},
    alias: productryg68fgQLAMeta?.alias || [],
    redirect: productryg68fgQLAMeta?.redirect || undefined,
    component: () => import("C:/Users/Administrator/Desktop/new_website/nuxt3Template-master/pages/product.vue").then(m => m.default || m)
  }
]